import { render, staticRenderFns } from "./EditSwapFee.vue?vue&type=template&id=b911b7de&"
import script from "./EditSwapFee.vue?vue&type=script&lang=js&"
export * from "./EditSwapFee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports